import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { endpoints } from "../../hooks/use-api";
import VerifyVoucher from "../Vouchers/VerifyVoucher"
import CreateOrUpdateVoucher from "../Vouchers/CreateVoucher";
import { Box, Typography } from "@mui/material";

const ModifyApplication = (props) => {
  const { identifier } = useParams();
  const [voucher, setVoucher] = useState(null);

  const onSuccess = (responseData, formData) => {
    if (responseData.valid) {
      setVoucher(responseData.voucher);
      return [true, ""];
    } else {
      const msg = responseData.message.length > 0 ? responseData.message : `Voucher number ${formData.voucherNumber} can not be modified`;
      return [false, msg]
    }
  }  

  return (
    <>
      {voucher === null && <VerifyVoucher
        title="Update Application"
        endpointFn={() => endpoints.apply.verify(identifier)}
        onSuccess={onSuccess} />}
      {voucher !== null && <Box sx={{ width: 700, mx: "auto", backgroundColor: "#fff" }}>
        <CreateOrUpdateVoucher
          individualApplication={voucher.voucher_detail.individual_application}
          voucher={voucher}
          createMode={false}
        />
      </Box>
      }
    </>
  );
};

export default ModifyApplication;
